import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ShowPointIconNew = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.5 10.875H11.5C11.1548 10.875 10.875 11.1548 10.875 11.5V12.5C10.875 12.8452 11.1548 13.125 11.5 13.125H12.5C12.8452 13.125 13.125 12.8452 13.125 12.5V11.5C13.125 11.1548 12.8452 10.875 12.5 10.875Z"
        fill={color}
      />
      <path
        d="M3.30798 20.067H2.30798C1.96281 20.067 1.68298 20.3468 1.68298 20.692V21.692C1.68298 22.0372 1.96281 22.317 2.30798 22.317H3.30798C3.65316 22.317 3.93298 22.0372 3.93298 21.692V20.692C3.93298 20.3468 3.65316 20.067 3.30798 20.067Z"
        fill={color}
      />
      <path
        d="M11.0861 19.36H10.0861C9.74088 19.36 9.46106 19.6398 9.46106 19.985V20.985C9.46106 21.3302 9.74088 21.61 10.0861 21.61H11.0861C11.4312 21.61 11.7111 21.3302 11.7111 20.985V19.985C11.7111 19.6398 11.4312 19.36 11.0861 19.36Z"
        fill={color}
      />
      <path
        d="M4.01501 12.2889H3.01501C2.66984 12.2889 2.39001 12.5688 2.39001 12.9139V13.9139C2.39001 14.2591 2.66984 14.5389 3.01501 14.5389H4.01501C4.36019 14.5389 4.64001 14.2591 4.64001 13.9139V12.9139C4.64001 12.5688 4.36019 12.2889 4.01501 12.2889Z"
        fill={color}
      />
      <path
        d="M7.63904 6.01404H6.63904C6.29386 6.01404 6.01404 6.29386 6.01404 6.63904V7.63904C6.01404 7.98422 6.29386 8.26404 6.63904 8.26404H7.63904C7.98422 8.26404 8.26404 7.98422 8.26404 7.63904V6.63904C8.26404 6.29386 7.98422 6.01404 7.63904 6.01404Z"
        fill={color}
      />
      <path
        d="M17.361 15.736H16.361C16.0158 15.736 15.736 16.0158 15.736 16.361V17.361C15.736 17.7061 16.0158 17.986 16.361 17.986H17.361C17.7061 17.986 17.986 17.7061 17.986 17.361V16.361C17.986 16.0158 17.7061 15.736 17.361 15.736Z"
        fill={color}
      />
      <path
        d="M20.985 9.46106H19.985C19.6398 9.46106 19.36 9.74088 19.36 10.0861V11.0861C19.36 11.4312 19.6398 11.7111 19.985 11.7111H20.985C21.3302 11.7111 21.61 11.4312 21.61 11.0861V10.0861C21.61 9.74088 21.3302 9.46106 20.985 9.46106Z"
        fill={color}
      />
      <path
        d="M13.9139 2.39001H12.9139C12.5688 2.39001 12.2889 2.66984 12.2889 3.01501V4.01501C12.2889 4.36019 12.5688 4.64001 12.9139 4.64001H13.9139C14.2591 4.64001 14.5389 4.36019 14.5389 4.01501V3.01501C14.5389 2.66984 14.2591 2.39001 13.9139 2.39001Z"
        fill={color}
      />
      <path
        d="M21.692 1.68298H20.692C20.3468 1.68298 20.067 1.96281 20.067 2.30798V3.30798C20.067 3.65316 20.3468 3.93298 20.692 3.93298H21.692C22.0372 3.93298 22.317 3.65316 22.317 3.30798V2.30798C22.317 1.96281 22.0372 1.68298 21.692 1.68298Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ShowPointIconNew.displayName = 'ShowPointIconNew';
